<div class="w-full overflow-x-auto lg:overflow-visible">
  <div class="flex flex-col lg:flex-row gap-1 items-center lg:items-start justify-center pt-1">

    <!-- Mes actual -->
    <div
      class="flex w-full lg:w-[300px] flex-col gap-0.5 bg-metro-secondary rounded-lg shadow-lg border border-metro-blue-secondary"
      [class.border-red-500]="error()"
    >
      <div class="flex items-center p-1 justify-between border-b border-metro-blue-secondary">
        <button
          (click)="prevMonth()"
          [disabled]="disabled()"
          class="hover:bg-gray-200 border-t rounded-full p-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span class="text-metro-black">‹</span>
        </button>
        <p class="text-metro-black text-base font-bold flex-1 text-center">
          {{ getMonthYearLabel(currentMonth()) }}
        </p>
        <div class="w-10"></div>
      </div>

      <div class="grid grid-cols-7 gap-1 p-2">
        @for (day of daysOfWeek; track day) {
          <div class="text-center text-metro-black text-sm font-medium py-2">
            {{ day }}
          </div>
        }
      </div>

      <div class="grid grid-cols-7 gap-1 p-2">
  @for (day of getCalendarDays(currentMonth()); track day.toString()) {
    <button
      (click)="isCurrentMonth(day, currentMonth()) ? selectDate(day, $event) : null"
      (mouseenter)="onMouseEnter(day)"
      (mouseleave)="onMouseLeave()"
      [disabled]="disabled() || !isCurrentMonth(day, currentMonth()!)"
      class="w-10 h-10 rounded-full flex items-center justify-center mx-auto"
      [class.text-metro-black]="isCurrentMonth(day, currentMonth()) && !isSelected(day) && !isRangeStart(day) && !isRangeEnd(day)"
      [class.text-white]="isCurrentMonth(day, currentMonth()) && (isSelected(day) || isRangeStart(day) || isRangeEnd(day))"
      [class.text-gray-400]="!isCurrentMonth(day, currentMonth())"
      [class.bg-metro-blue]="isCurrentMonth(day, currentMonth()) && (isSelected(day) || isRangeStart(day) || isRangeEnd(day))"
      [class.border-2]="isCurrentMonth(day, currentMonth()) && (isSelected(day) || isRangeStart(day) || isRangeEnd(day))"
      [class.border-2]="isCurrentMonth(day, currentMonth()) && isInRange(day)"
      [class.rounded-l-full]="isCurrentMonth(day, currentMonth()) && isRangeStart(day)"
      [class.rounded-r-full]="isCurrentMonth(day, currentMonth()) && isRangeEnd(day)"
      [class.hover:border-2]="!disabled() && isCurrentMonth(day, currentMonth()) && !isSelected(day)"
      [class.font-bold]="isCurrentMonth(day, currentMonth()) && (isSelected(day) || isRangeEdge(day))"
      [class.opacity-50]="disabled() || !currentMonth()">
      {{ day.day }}
    </button>
  }
</div>
    </div>

    <!-- Mes siguiente -->
    <div
      class="flex w-full lg:w-[300px] flex-col gap-0.5 bg-metro-secondary rounded-lg shadow-lg border border-metro-blue-secondary"
      [class.border-red-500]="error()"
    >
      <div class="flex items-center p-1 justify-between border-b border-metro-blue-secondary">
        <div class="w-10"></div>
        <p class="text-metro-black text-base font-bold flex-1 text-center">
          {{ getMonthYearLabel(nextMonth()) }}
        </p>
        <button
          (click)="advanceMonth()"
          [disabled]="disabled()"
          class="hover:bg-metro-blue-secondary rounded-full p-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span class="text-metro-black">›</span>
        </button>
      </div>

      <div class="grid grid-cols-7 gap-1 p-2">
        @for (day of daysOfWeek; track day) {
          <div class="text-center text-metro-black text-sm font-medium py-2">
            {{ day }}
          </div>
        }
      </div>

      <div class="grid grid-cols-7 gap-1 p-2">
  @for (day of getCalendarDays(nextMonth()); track day.toString()) {
    <button
      (click)="isCurrentMonth(day, nextMonth()) ? selectDate(day, $event) : null"
      (mouseenter)="onMouseEnter(day)"
      (mouseleave)="onMouseLeave()"
      [disabled]="disabled() || !isCurrentMonth(day, nextMonth())"
      class="w-10 h-10 rounded-full flex items-center justify-center mx-auto"
      [class.text-metro-black]="isCurrentMonth(day, nextMonth()) && !isSelected(day) && !isRangeStart(day) && !isRangeEnd(day)"
      [class.text-white]="isCurrentMonth(day, nextMonth()) && (isSelected(day) || isRangeStart(day) || isRangeEnd(day))"
      [class.text-gray-400]="!isCurrentMonth(day, nextMonth())"
      [class.bg-gray-400]="isCurrentMonth(day, nextMonth()) && (isSelected(day) || isRangeStart(day) || isRangeEnd(day))"
       [class.border-2]="isCurrentMonth(day, nextMonth()) && (isSelected(day) || isRangeStart(day) || isRangeEnd(day))"
      [class.border-2]="isCurrentMonth(day, nextMonth()) && isInRange(day)"
      [class.rounded-l-full]="isCurrentMonth(day, nextMonth()) && isRangeStart(day)"
      [class.rounded-r-full]="isCurrentMonth(day, nextMonth()) && isRangeEnd(day)"
      [class.hover:border-2]="!disabled() && isCurrentMonth(day, nextMonth()) && !isSelected(day)"
      [class.font-bold]="isCurrentMonth(day, nextMonth()) && (isSelected(day) || isRangeEdge(day))"
      [class.opacity-50]="disabled()"
    >
      {{ day.day }}
    </button>
  }
</div>
    </div>
  </div>
</div>

@if (error()) {
  <div class="text-red-500 text-sm px-4 pb-2 w-full text-center">
    {{ error() }}
  </div>
}
